import React from 'react';
import ButtonSwitchMulti from '../../../components/actions/ButtonSwitchMulti';

export interface KpiFeatureToggleConfig {
  key: string;
  label: string;
  value: boolean;
  setValue: (v: boolean) => void;
}

interface KpiFeatureTogglesProps {
  toggles: KpiFeatureToggleConfig[];
  className?: string;
}

const KpiFeatureToggles: React.FC<KpiFeatureTogglesProps> = ({
  toggles,
  className,
}) => {
  return (
    <div
      data-component="KpiFeatureToggles"
      className={`my-2 flex flex-wrap items-center gap-2 ${className || ''}`}
    >
      {toggles.map(toggle => (
        <ButtonSwitchMulti
          key={toggle.key}
          className="flex-1"
          options={[{ label: 'Off' }, { label: 'On' }]}
          selectedIndex={toggle.value ? 1 : 0}
          buttonType={toggle.value ? 'secondary' : 'minimal'}
          onClick={i => toggle.setValue(i === 1)}
          title={toggle.label}
          autoSize
        />
      ))}
    </div>
  );
};

export default KpiFeatureToggles;
